module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_tag-8d378cb340476dc9c52e3ccff2ae6420.png";